$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('contact-us')) {
    customElements.define(
      'contact-us',
      class contactUs extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.init();
        }
        init() {
          this.submitButton = this.querySelector('.contact-us-form-button');
          this.form = this.querySelector('.contact-us-form');

          // 设置失去焦点验证
          this.setupBlurValidation();

          this.submitButton.addEventListener('click', (e) => {
            e.preventDefault();
            // 添加表单验证
            if (this.validateForm()) {
              this.form.submit();
            }
          });
        }

        /**
         * 失去焦点的时候验证格式是否正确
         */
        setupBlurValidation() {
          const inputs = this.querySelectorAll('input, textarea');
          inputs.forEach((input) => {
            // 当鼠标失去焦点时验证字段
            input.addEventListener('blur', () => {
              this.validateField(input);
            });
          });
        }

        /**
         * 验证表单正则
         */
        validateForm() {
          let isValid = true;

          // 验证必填字段
          const requiredFields = ['contact[first_name]', 'contact[last_name]', 'contact[email]', 'contact[message]'];

          requiredFields.forEach((fieldName) => {
            const field = this.querySelector(`[name="${fieldName}"]`);
            if (field && !this.validateField(field)) {
              isValid = false;
            }
          });

          return isValid;
        }

        /**
         * 验证单个字段
         */
        validateField(field) {
          const fieldName = field.name;
          const value = field.value.trim();
          let isValid = true;
          let errorMessage = '';

          // 根据字段类型进行验证
          switch (fieldName) {
            case 'contact[first_name]':
              if (!value) {
                isValid = false;
                errorMessage = this.getAttribute('data-first-name-error');
              }
              break;

            case 'contact[last_name]':
              if (!value) {
                isValid = false;
                errorMessage = this.getAttribute('data-last-name-error');
              }
              break;

            case 'contact[email]':
              if (!value) {
                isValid = false;
                errorMessage = this.getAttribute('data-email-error');
              } else if (!this.isValidEmail(value)) {
                isValid = false;
                errorMessage = this.getAttribute('data-email-format-error');
              }
              break;

            case 'contact[message]':
              if (!value) {
                isValid = false;
                errorMessage = this.getAttribute('data-message-error');
              }
              break;
          }

          this.toggleFieldError(field, isValid, errorMessage);
          return isValid;
        }

        /**
         * 验证邮箱格式
         */
        isValidEmail(email) {
          const emailRegex = ltUtils.rule.email;
          return emailRegex.test(email);
        }

        /**
         * 切换字段错误状态
         */
        toggleFieldError(field, isValid, errorMessage = '') {
          const errorElement = field.nextElementSibling;

          if (!isValid) {
            field.classList.add('error');
            if (errorElement && errorElement.classList.contains('error-message')) {
              errorElement.textContent = errorMessage;
              errorElement.classList.remove('hidden');
            }
          } else {
            field.classList.remove('error');
            if (errorElement && errorElement.classList.contains('error-message')) {
              errorElement.classList.add('hidden');
            }
          }
        }
      }
    );
  }
});
